// export let baseUrl = 'https://gci.oointer.com'
export let baseUrl = 'https://www.globalcareinfo.com/api'


